import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service to track loading state across components
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  // Track loading status for each component with default true (loading)
  private singleTreeLoading = new BehaviorSubject<boolean>(true);
  private mainAreaLoading = new BehaviorSubject<boolean>(true);
  private detailsAreaLoading = new BehaviorSubject<boolean>(true);
  
  // Master loading state that combines all component states
  private appLoading = new BehaviorSubject<boolean>(true);

  constructor() {
    this.updateAppLoadingState();
  }

  // Public observables for components to subscribe to
  get singleTreeLoading$(): Observable<boolean> {
    return this.singleTreeLoading.asObservable();
  }

  get mainAreaLoading$(): Observable<boolean> {
    return this.mainAreaLoading.asObservable();
  }

  get detailsAreaLoading$(): Observable<boolean> {
    return this.detailsAreaLoading.asObservable();
  }

  get appLoading$(): Observable<boolean> {
    return this.appLoading.asObservable();
  }

  // Methods for components to update their loading status
  setSingleTreeLoaded(): void {
    this.singleTreeLoading.next(false);
    this.updateAppLoadingState();
  }

  setMainAreaLoaded(): void {
    this.mainAreaLoading.next(false);
    this.updateAppLoadingState();
  }

  setDetailsAreaLoaded(): void {
    this.detailsAreaLoading.next(false);
    this.updateAppLoadingState();
  }

  // Reset all states to loading (e.g., when navigating to a new page)
  resetLoadingState(): void {
    this.singleTreeLoading.next(true);
    this.mainAreaLoading.next(true);
    this.detailsAreaLoading.next(true);
    this.updateAppLoadingState();
  }

  // Update the master loading state based on individual component states
  private updateAppLoadingState(): void {
    const isLoading = 
      this.singleTreeLoading.value || 
      this.mainAreaLoading.value || 
      this.detailsAreaLoading.value;
    
    this.appLoading.next(isLoading);
  }
} 